import React, { useCallback, useMemo } from 'react'
import {
  TitleDescContainer,
  TitleWrapper,
  DescWrapper,
  ItemWrapper,
} from '~/app/components/Cart/CartGroup/CartGroup.style'
import DomesticLeisureItem, {
  LeisureOption,
} from '~/app/components/Cart/CartItem/DomesticLeisureItem'
import { CategoryType } from '~/__generated__/__types__'

/**
 * DomesticLeisureGroup component
 * author: jaegeunlee
 * description
 */
interface DomesticLeisureGroupProps {
  currentAt: string
  dealName: string
  type: CategoryType
  options: LeisureOption[]
  onCheck?: (checked: boolean, id: string) => void
  onChange?: (quantity: number, id: string) => void
  onClose?: (id: string) => void
  onTitleClick?: (id: string) => void
}

const DomesticLeisureGroup: React.FC<DomesticLeisureGroupProps> = props => {
  const onGroupTitleClick = useCallback(() => {
    props.onTitleClick?.(props.options?.[0]?.id)
  }, [props.options])
  const categoryName = useMemo(() => {
    if (props.type === CategoryType.DomesticLeisureGiftcard) {
      return '모바일교환권'
    } else if (props.type === CategoryType.DomesticLeisureRentacar) {
      return '교통'
    } else {
      return '국내레저'
    }
  }, [props.type])

  return (
    <>
      <TitleDescContainer>
        <TitleWrapper onClick={onGroupTitleClick}>{props.dealName}</TitleWrapper>
        <DescWrapper>{categoryName}</DescWrapper>
      </TitleDescContainer>
      {props.options.map(option => (
        <ItemWrapper key={option.id}>
          <DomesticLeisureItem
            currentAt={props.currentAt}
            product={option.product}
            option={option}
            onCheck={props.onCheck}
            onChange={props.onChange}
            onClose={props.onClose}
            onTitleClick={props.onTitleClick}
          />
        </ItemWrapper>
      ))}
    </>
  )
}

export default DomesticLeisureGroup
